import { Trash2, X } from "lucide-react";
import { useState, useEffect } from "react";
import DealStagePopup from "../DealStagePopup";
import { toast } from "react-toastify";
import { useStateValue } from "../../context/StateProvider";
import {
  getAlldealforAdmin,
  getDealById,
  updateItem,
} from "../../utils/firebasefunctions";
import {
  formatCurrency,
  formatDate,
  formatNumberShort,
} from "../../utils/helper";
import Chat from "./chat";
import DocumentsTab from "../documents/DocumentsTab";
import PropertyImage from "../deal-detail/property-image";
import DealLocation from "../deal-detail/deal-location";
import ComissionBreakDown from "../deal-detail/comission-breakdown";
import PeopleInvolve from "../deal-detail/people-involved";
import ClientInform from "../deal-detail/client-inform";
import Task from "./task";
import StickyNote from "./sticky-note";
import DeleteDeal from "../deals/delete-deal";
import { useNavigate } from "react-router-dom";
import { actionType } from "../../context/reducer";
import ListingDetail from "../deal-detail/listing-details";

function DealDetail({ deal, onClose }) {
  const [{ user, deals, employees }, dispatch] = useStateValue();
  const [activeTab, setActiveTab] = useState("overview");
  // Local copy so the Transaction Emails panel reflects sent/skipped status
  // immediately after an action (the panel also persists to Firestore).
  const [dealData, setDealData] = useState(deal);
  useEffect(() => {
    setDealData(deal);
  }, [deal]);
  const [editdata, seteditdata] = useState({});
  const [isDelete, setIsDelete] = useState(false);
  const isMobile = window.innerWidth < 1024;

  const navigate = useNavigate();

  const tabs = isMobile
    ? ["overview", "documents", "task", "chat"]
    : ["overview", "documents", "task"];

  const getAgent = (data) => {
    const agent = employees.find((x) => x.id === data.createdby);
    if (!agent) return ""; // agar agent na mile

    return `${agent.firstname} ${agent.lastname}`;
  };

  const handleDelete = (data) => {
    seteditdata(data);
    setIsDelete(true);
  };

  const handleDeal = () => {
    getalldeal(false);
  };

  async function getalldeal(isClose = true) {
    await getAlldealforAdmin("deals")
      .then(async (response) => {
        dispatch({
          type: actionType.STORE_DEALS,
          deals: response,
        });
        if (isClose) {
          onClose();
        }
      })
      .catch((err) => {
        alert(err);
      });
  }

  return (
    <>
      <div
        className="fixed inset-0 bg-black/50 z-40 transition-opacity"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-6 pointer-events-none">
        <div className="rounded-xl shadow-2xl w-full max-w-5xl max-h-[calc(100vh-5rem)] bg-white flex flex-col overflow-hidden pointer-events-auto">
          {/* Header — slim, auto-height */}
          <div className="flex items-center justify-between px-5 py-3 border-b border-black/10 bg-[#1E293B] text-white w-full shrink-0">
            <h2 className="text-base font-semibold">Deal Details</h2>
            <div className="flex items-center gap-2">
              {/* View Detail used to live inside the embedded DealSummary
                  header; that header is hidden when DealSummary is embedded,
                  so we promote the action to the panel header instead. */}
              <button
                onClick={() =>
                  navigate(
                    `/dashboard/deals-detail/${deal.createdat}?page=deal-board`,
                  )
                }
                className="bg-white/15 hover:bg-white/25 text-white text-sm font-semibold px-3 py-1.5 rounded-md transition"
              >
                View Detail
              </button>
              <button
                onClick={onClose}
                className="w-8 h-8 bg-white/15 hover:bg-white/25 rounded-full flex items-center justify-center transition-all hover:rotate-90"
              >
                <X className="w-5 h-5 text-foreground" />
              </button>
            </div>
          </div>
          {/* Body — fills remaining space */}
          <div className="flex flex-col-reverse lg:flex-row flex-1 min-h-0">
            <div className="lg:w-[60%] panelScroll lg:overflow-y-auto mt-5 lg:mt-0 min-h-0">
              <div className="flex gap-x-2 px-6 border-b border-b-white/6 sticky top-0 z-20 bg-white">
                {tabs.map((tab) => (
                  <button
                    key={tab}
                    onClick={() => setActiveTab(tab)}
                    className={`py-2 px-3 text-sm font-semibold cursor-pointer border-b-2 transition-all ${
                      activeTab === tab
                        ? "text-slate-900 border-b-slate-900"
                        : "text-slate-400 border-b-transparent"
                    }`}
                  >
                    {tab === "documents"
                      ? "📁 Documents"
                      : tab === "task"
                        ? "📋 Task"
                        : tab === "chat"
                          ? "💬 Chat"
                          : "📊 Overview"}
                  </button>
                ))}
              </div>
              {activeTab === "overview" && (
                <div className="w-[96%] mx-auto my-4">
                  {/* LEFT SECTION */}
                  <div className="space-y-3">
                    {/* Property Image */}

                    {/* <div className="bg-white rounded-xl shadow overflow-hidden">
                      <img
                        src={
                          deal?.propertyphoto?.length > 0
                            ? deal?.propertyphoto[0]
                            : "/assets/broken.png"
                        }
                        onError={(e) => {
                          e.currentTarget.src = "/assets/broken.png"; // fallback when broken
                        }}
                        className="w-full h-72 object-cover"
                        alt="Property"
                      />
                      <div className="p-5">
                        <h2 className="text-xl font-semibold text-gray-800">
                          {deal.propertyaddress}
                        </h2>
                        <p className="text-gray-500">{deal.propertyType}</p>
                      </div>
                    </div> */}
                    <PropertyImage deal={deal} />
                    {/* <div className="overflow-x-hidden"> */}
                    <StickyNote deal={deal} />
                    {/* </div> */}

                    {/* Standalone Deal Summary removed — ListingDetail
                        below embeds the same DealSummary internally, so
                        keeping both on this panel rendered the static
                        fields twice. */}
                    <ListingDetail deal={deal} onSubmit={() => handleDeal()} />

                    {/* Location */}
                    {deal.propertyaddress && <DealLocation deal={deal} />}
                  </div>

                  {/* RIGHT SECTION */}
                  <div className="space-y-4 mt-5">
                    {/* Commissions Breakdown */}
                    {deal.status === "Approved" && deal?.offerPrice && (
                      <ComissionBreakDown deal={deal} />
                    )}

                    {/* Transaction emails moved to the full Email Center tab
                        on the Deal Detail page — link there from the popup. */}
                    <div className="bg-white rounded-2xl border border-gray-200 shadow-sm px-4 py-3 flex items-center justify-between gap-3">
                      <div>
                        <p className="font-semibold text-slate-900 text-sm">Transaction Emails</p>
                        <p className="text-xs text-slate-400">
                          Compose, attach documents, and track sends in the Email Center.
                        </p>
                      </div>
                      <button
                        onClick={() =>
                          navigate(
                            `/dashboard/deals-detail/${deal.createdat}?page=deal-board&type=emails`,
                          )
                        }
                        className="text-xs font-semibold text-white bg-themeColor rounded px-3 py-1.5 whitespace-nowrap"
                      >
                        Open Email Center
                      </button>
                    </div>

                    {/* People Section */}
                    <PeopleInvolve
                      deal={deal}
                      getAgent={(deal) => getAgent(deal)}
                    />

                    {/* Client Information */}
                    {deal.customers.length > 0 && <ClientInform deal={deal} />}
                  </div>
                </div>
              )}
              {activeTab === "documents" && <DocumentsTab deal={deal} />}
              {activeTab === "task" && <Task deal={deal} />}
              {activeTab === "chat" && (
                <div className="lg:hidden">
                  <Chat data={deal} />
                </div>
              )}
            </div>
            <div className="lg:w-[39%] hidden lg:block lg:overflow-y-auto min-h-0 border-l border-slate-100">
              <Chat data={deal} />
            </div>
          </div>
        </div>
        {isDelete && (
          <DeleteDeal
            deal={editdata}
            onClose={() => {
              setIsDelete(false)
            }}
            closepopup={()=>{
              onClose()
            }}
            onSubmit={() => {
              handleDeal();
            }}
          />
        )}
      </div>
    </>
  );
}
export default DealDetail;
